import React, { useState } from 'react';
import {
    TextField,
    Grid,
    Typography,
    Button,
    Box,
    IconButton,
    InputAdornment
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import API from '../../utils/Axios.utils';

// Yup Validation Schema
const passwordValidationSchema = Yup.object({
    newPassword: Yup.string().required('New password is required'),
    confirmPassword: Yup.string()
        .oneOf([Yup.ref('newPassword'), null], 'Passwords must match')
        .required('Confirm password is required'),
});

const ChangePassword = () => {
    const [newPasswordVisible, setNewPasswordVisible] = useState(false);
    const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
    const user = JSON.parse(localStorage.getItem('userLoggedIn'));
    return (
        <Formik
            initialValues={{ newPassword: '', confirmPassword: '' }}
            validationSchema={passwordValidationSchema}
            onSubmit={(values) => {
                const payload = {
                    user_id: user?.user_id || '',
                    new_password: values?.newPassword || '',
                    confirm_password: values?.confirmPassword || ''
                }
                const config = {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                };
                API.post(`/api/users/change-password`, payload, config)
                    .then((res) => {
                        // handlePopup();
                    })
                    .catch((err) => {
                        console.log('Edit error :- ', err);
                    })
            }}
        >
            {({ touched, errors }) => (
                <Form>
                    <Typography variant="subtitle1" fontWeight="bold" mb={2}>
                        Change Password
                    </Typography>
                    <Grid container spacing={3} mb={2}>
                        {/* New Password Field */}
                        <Grid item xs={12} md={6}>
                            <Field
                                as={TextField}
                                name="newPassword"
                                label="New password"
                                type={newPasswordVisible ? 'text' : 'password'}
                                fullWidth
                                variant="outlined"
                                error={touched.newPassword && Boolean(errors.newPassword)}
                                helperText={<ErrorMessage name="newPassword" />}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                onClick={() => setNewPasswordVisible((prev) => !prev)}
                                                edge="end"
                                            >
                                                {newPasswordVisible ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                    )
                                }}
                            />
                        </Grid>

                        {/* Confirm Password Field */}
                        <Grid item xs={12} md={6}>
                            <Field
                                as={TextField}
                                name="confirmPassword"
                                label="Confirm password"
                                type={confirmPasswordVisible ? 'text' : 'password'}
                                fullWidth
                                variant="outlined"
                                error={touched.confirmPassword && Boolean(errors.confirmPassword)}
                                helperText={<ErrorMessage name="confirmPassword" />}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                onClick={() => setConfirmPasswordVisible((prev) => !prev)}
                                                edge="end"
                                            >
                                                {confirmPasswordVisible ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                    )
                                }}
                            />
                        </Grid>
                    </Grid>

                    {/* Submit Button */}
                    <Box display="flex" justifyContent="flex-end">
                        <Button
                            type="submit"
                            variant="contained"
                            sx={{
                                backgroundColor: '#1976d2',
                                '&:hover': {
                                    backgroundColor: '#1976d2',
                                },
                                mb: 4
                            }}
                        >
                            Change Password
                        </Button>
                    </Box>
                </Form>
            )}
        </Formik>
    );
};

export default ChangePassword;
